export function Home() {
    return <h1>MY Home</h1>
}